// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react'
import { Route, Switch } from 'react-router-dom'
import Page from '../../common/page/Page'
import RestrictedRoute from '../auth/RestrictedRoute'
import css from './Admin.css'
import ChainRoot from './chain/ChainRoot'
import GuidelinesAndLinks from './guidelinesAndLinks/GuidelinesAndLinks'
import IntroductionLinks from './introductionLinks/IntroductionLinks'
import StationRoot from './station/StationRoot'
import Users from './users/Users'
import VitrineProductRoot from './vitrineProduct/VitrineProductRoot'

function Admin() {
  return (
    <Page className={css.component}>
      <Switch>
        <RestrictedRoute requiredPermission='manage_chain' path='/yllapito/ketju' component={ChainRoot} />
        <RestrictedRoute requiredPermission='manage_users' path='/yllapito/kayttajat' component={Users} />
        <Route path='/yllapito/toimipaikat' component={StationRoot} />
        <RestrictedRoute
          requiredPermission='manage_vitrineProducts'
          path='/yllapito/vitriinituotteet'
          component={VitrineProductRoot}
        />
        <RestrictedRoute
          requiredPermission='nav_admin'
          path='/yllapito/ohjeet-ja-linkit'
          component={GuidelinesAndLinks}
        />
        <RestrictedRoute requiredPermission='nav_admin' path='/yllapito/perehdytys' component={IntroductionLinks} />
      </Switch>
    </Page>
  )
}

export default Admin
